export const Filter = {
  white: 'invert(100%)',
  primary:
    'invert(34%) sepia(58%) saturate(411%) hue-rotate(184deg) brightness(93%) contrast(95%)',
  labelBrown:
    'brightness(0) saturate(100%) invert(22%) sepia(30%) saturate(1808%) hue-rotate(351deg) brightness(92%) contrast(95%)',
  onSurfaceVariant:
    'brightness(0) saturate(100%) invert(27%) sepia(8%) saturate(511%) hue-rotate(191deg) brightness(92%) contrast(88%)',
};
